"use client";

import Header from "@/layout/headers/header";
import Wrapper from "@/layout/wrapper";
import Footer from "@/layout/footers/footer";
import { Suspense } from "react";
import Loading from "./loading";

export default function TermsAndConditionsPage() {
  return (
    <Wrapper>
      <Header />

      <main>
        <Suspense fallback={<Loading />}>
          <section
            style={{
              padding: "80px 16px",
              background: "#ffff",
            }}
          >
            <div className="container d-flex justify-content-center">

              <div className="policy-card">

                <h1 className="policy-title">
                  iMall Terms & Conditions
                </h1>

                <p className="policy-sub">
                  Please read these terms carefully before using our website.
                </p>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>📜 General Terms</h4>
                  <p>
                    iMall is an online marketplace platform. By accessing or 
                    using our website, you agree to comply with these Terms 
                    and Conditions. If you do not agree, please refrain from 
                    using our services.
                  </p>
                </div>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>🔁 Policy Changes</h4>
                  <p>
                    iMall reserves the right to modify, update, or remove 
                    any part of these terms at any time without prior notice. 
                    Please review this page periodically for updates.
                  </p>
                </div>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>👤 Account Responsibility</h4>
                  <ol>
                    <li>You must provide accurate information when creating an account.</li>
                    <li>You are responsible for keeping your login credentials secure.</li>
                    <li>You must notify us immediately of any suspicious activity.</li>
                  </ol>
                </div>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>🛍️ Products & Content</h4>
                  <ol>
                    <li>Product images and descriptions are for informational purposes only.</li>
                    <li>Information may not always be fully updated due to supplier changes.</li>
                    <li>Please verify details before placing an order.</li>
                    <li>Unauthorized commercial use of website content is strictly prohibited.</li>
                  </ol>
                </div>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>📦 Stock & Orders</h4>
                  <ol>
                    <li>Stock availability may change in real-time.</li>
                    <li>Orders may be cancelled if items become unavailable.</li>
                    <li>Customers will be notified via SMS or Email if necessary.</li>
                  </ol>
                </div>

                {/* SECTION */}
                <div className="policy-section">
                  <h4>✅ Order Verification</h4>
                  <p>
                    To prevent fraud, iMall reserves the right to verify 
                    payment and personal information. Orders may be cancelled 
                    without prior notice if incorrect information is provided.
                  </p>
                </div>

                <div className="policy-note">
                  ⚠️ iMall reserves the right to suspend accounts or discontinue services at any time.
                </div>

              </div>

            </div>
          </section>
        </Suspense>
      </main>

      <Footer />

      <style jsx>{`
        .policy-card {
          max-width: 860px;
          background: rgba(255,255,255,0.98);
          padding: 50px 40px;
          border-radius: 18px;
          border: 1px solid rgba(255,122,0,0.15);
          box-shadow: 0 12px 36px rgba(0,0,0,.08);
          transition: .3s ease;
        }

        .policy-card:hover{
          transform: translateY(-3px);
        }

        .policy-title{
          text-align:center;
          font-size:36px;
          font-weight:800;
          letter-spacing:1.2px;
          background: linear-gradient(135deg,#ff7a00,#ff3d00,#ff9800);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin-bottom:8px;
        }

        .policy-sub{
          text-align:center;
          color:#666;
          margin-bottom:35px;
          font-size:14px;
          letter-spacing:.6px;
        }

        .policy-section{
          margin-bottom:28px;
        }

        .policy-section h4{
          font-weight:700;
          margin-bottom:12px;
          color:#ff6a00;
        }

        .policy-section ol{
          padding-left:22px;
          margin:0;
        }

        .policy-section li{
          margin-bottom:8px;
          font-size:15px;
          color:#333;
          line-height:1.7;
        }

        .policy-section p{
          margin:0;
          font-size:15px;
          color:#444;
          line-height:1.7;
        }

        .policy-note{
          background:rgba(255,122,0,0.08);
          color:#d35400;
          padding:12px 16px;
          border-radius:12px;
          font-size:14px;
          border-left:4px solid #ff7a00;
        }

        @media(max-width:576px){
          .policy-card{
            padding:28px 18px;
          }
          .policy-title{
            font-size:26px;
          }
        }
      `}</style>

    </Wrapper>
  );
}
